export enum ProductDetailOutlets {
  PAGE = 'PDP.PAGE',
  SUMMARY = 'PDP.SUMMARY',
  IMAGES = 'PDP.IMAGES',
  TAB = 'PDP.TAB',
  DESCRIPTION = 'PDP.DESCRIPTION',
  SPECIFICATIONS = 'PDP.SPECIFICATIONS',
  REVIEWS = 'PDP.REVIEWS',
  SHIPPING = 'PDP.SHIPPING',
  TITLE = 'PDP.TITLE',
  RATING = 'PDP.RATING',
  ADDTOCART = 'PDP.ADDTOCART',
  PRICE = 'PDP.PRICE',
  SHARE = 'PDP.SHARE'
}
